import PendoGuide from './PendoGuide';

const PENDO_FEEDBACK_GUIDE = 'aca-featurefeedback';

export default class FeedbackGuide extends PendoGuide {
    _getGuideName() {
        return this._getGuideNameIfActive(PENDO_FEEDBACK_GUIDE);
    }
}